import { useDispatch } from ".";
import { CurrencySmallIcon } from "../components/CurrencySmallIcon/CurrencySmallIcon";
import { DEFAUL_TASK_REWARD } from "../constants";
import { setBalanceError } from "../redux/user";

export enum BalanceErrorType {
    Draw = 'участия в розыгрыше',
    WorkUpgrade = 'улучшения',
    Boost = 'усиления',
    BusinessStart = 'старта бизнеса',
    BusinessAreaCharUpgrade = 'увеличения площади',
    BusinessStaffCharUpgrade = 'увеличения персонала',
    BusinessElementUpgrade = 'улучшения',
    WheelOfFortunePaidSpin = 'платной попытки в Колесе Фортуны',
}

export const createBalanceErrorMessage = (cost: number, errorType: BalanceErrorType) => {    
    // TODO Get reward values from backend
    // TODO Remove referal reward from getTasks backend response
    const referalReward = 500000;

    return (
        <>
            <p>
                Для {errorType} требуется <CurrencySmallIcon value={ cost } />
            </p>
            <p>
                Заработать для {errorType} можно выполняя задания, например, пригласив друга Вы получите
                {' '}<CurrencySmallIcon value={ referalReward } />
                , а подписавшись на канал
                {' '}<CurrencySmallIcon value={ DEFAUL_TASK_REWARD } />
            </p>
        </>
    );
}

export const useBalanceError = () => {
    const dispatch = useDispatch();
  
    const handleBalanceError = (cost: number, errorType: BalanceErrorType) => {
        const errorMessage = createBalanceErrorMessage(cost, errorType);
        dispatch(setBalanceError(errorMessage));
    };
  
    return handleBalanceError;
};